module.exports = __webpack_public_path__ + "static/media/stage-clip-logo.e1e74f3f.png";